import RouteModel from "../../model-factory/basic/route/RouteModel";
import {FactoryID} from "../../model-factory/type-interface/ModelFactoryType";
import RouteFactory from "../../model-factory/basic/route/RouteFactory";
import RouteChoice from "../../model-factory/basic/route/RouteChoice";
import {IRouteIDs} from "../../model-factory/type-interface/ModelFactoryInterface";
import {IStringObject} from "../../common/SimpleInterface";
import {SearchParams} from "../../data/search/SearchBasicDataFactory";
import {SearchPageBasicDataModel} from "../../data/search/SearchPageBasicDataFactory";

export class SearchRelatedRouteVO
{
    entryIndex: number = -1;
    numberOfEntries: number = 0;
    pageNumber: number = 0;
    previousEntryPageNumber: number = 0;
    nextEntryPageNumber: number = 0;
    parentPage:RouteChoice|null = null;
    previousEntryParentPage:RouteChoice|null = null;
    previousEntry:RouteChoice|null = null;
    nextEntry:RouteChoice|null = null;
}

export class SearchBasicPageListRouteModel extends RouteModel
{

    allowUnknownChoice:boolean = true;
    defaultChoiceID:string = "1";
    doCreateChoicesFromSource:boolean = true;

    sourceDataModel:SearchPageBasicDataModel | null = null;
    searchParams:SearchParams = new SearchParams();

    applyModelConditions()
    {
        super.applyModelConditions();

        this.searchParams.applyModelConditions(this.populateIDs)
    }

    async getRelatedRoutes(entryID:string): Promise<SearchRelatedRouteVO>
    {
        const relatedRouteVO = new SearchRelatedRouteVO();
        if(!this.sourceDataModel){
            return relatedRouteVO;
        }

        return this.sourceDataModel.getRelatedData(entryID).then(relatedDataVO=> {
            const pageNumber = relatedDataVO.pageNumber && this.choices[relatedDataVO.pageNumber] ? relatedDataVO.pageNumber : 1;
            const previousEntryPageNumber = relatedDataVO.previousEntryPageNumber && this.choices[relatedDataVO.previousEntryPageNumber] ? relatedDataVO.previousEntryPageNumber : 1;
            relatedRouteVO.parentPage = this.choices[pageNumber] ?? null;
            relatedRouteVO.previousEntryParentPage = this.choices[previousEntryPageNumber] ?? null;
            const entryModel = this.entryModel();
            if(entryModel){
                relatedRouteVO.previousEntry = relatedDataVO.previousEntry ? (entryModel.choices[relatedDataVO.previousEntry.id] ?? null) : null;
                relatedRouteVO.nextEntry = relatedDataVO.nextEntry ? (entryModel.choices[relatedDataVO.nextEntry.id] ?? null) : null;
            }
            relatedRouteVO.entryIndex = relatedDataVO.entryIndex;
            relatedRouteVO.numberOfEntries = relatedDataVO.numberOfEntries;
            relatedRouteVO.pageNumber = pageNumber;
            relatedRouteVO.previousEntryPageNumber = relatedDataVO.previousEntryPageNumber;
            relatedRouteVO.nextEntryPageNumber = relatedDataVO.nextEntryPageNumber;
            return relatedRouteVO;
        })
    }

    entryModel():RouteModel|null
    {
        return null;
    }

    requireSourceDataModel(): SearchPageBasicDataModel | null
    {
        return null;
    }
}

export default class SearchBasicListRouteFactory extends RouteFactory
{
    constructor()
    {
        super();


        this.choices = {
            "1": new RouteChoice({
                name: "1"
            })
        }
    }

    getValidParamKeys(routeIDs:IRouteIDs, params:IStringObject):string[]
    {
        return params.all ? ["all"] : ["s"];
    }

    getAdditionalRouteIDs(routeIDs: IRouteIDs, params: IStringObject, hash: string, suppliedRouteIDs?: IRouteIDs|null): IRouteIDs
    {
        const additionalIDs = super.getAdditionalRouteIDs(routeIDs, params, hash, suppliedRouteIDs);

        if(suppliedRouteIDs?.search_term_id){
            additionalIDs.search_term_id = suppliedRouteIDs.search_term_id;
        } else if(params.all){
            additionalIDs.search_term_id = "search_all";
        } else if(params.s){
            additionalIDs.search_term_id = params.s
        }
        if(suppliedRouteIDs?.search_sort_by){
            additionalIDs.search_sort_by = suppliedRouteIDs.search_sort_by;
        }

        return additionalIDs;
    }

    birth(id: FactoryID): SearchBasicPageListRouteModel
    {
        return new SearchBasicPageListRouteModel(id);
    }
}